import DOMPurify from 'dompurify';
import { useMemo } from 'react';

export const sanitizeText = (text?: string): string | null => {
	return text?.length
		? DOMPurify.sanitize(text, {
				ALLOWED_URI_REGEXP:
					//!allow specific protocols handlers in URL attributes via regex (default is false, be careful, XSS risk)
					// by default only http, https, ftp, ftps, tel, mailto, callto, cid and xmpp are allowed.
					// /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|xxx|tg|android-app|https):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
					/(([a-zA-Z\-_]+:\/\/)|(mailto:))/i,
		  })
		: null;
};
export const useSanitize = (text?: string): { __html: string } | null =>
	useMemo(() => {
		const sanitized = sanitizeText(text);
		if (sanitized) {
			return { __html: sanitized };
		} else {
			return null;
		}
	}, [text]);

//добавляйте атрибут, только если полностью уверены в его безопасности
DOMPurify.addHook('afterSanitizeAttributes', function (node) {
	if (node.tagName === 'A' && 'target' in node) {
		node.setAttribute('target', '_blank');
		node.setAttribute('rel', 'noreferrer');
	}
});
